import React, {Component} from "react";
import ApiResourceHelper from "../../../helpers/ApiResourceHelper";
import {toast} from "react-toastify";
import _ from "lodash";
import paginate from "../../../utils/paginate";
import {Dropdown} from "react-bootstrap";
import {FaEllipsisH, FaEye} from "react-icons/all";
import {Link} from "react-router-dom";
import Table from "../../../components/Table";
import {getDate} from "../../../utils/utils";
import moment from "moment";

class LogList extends Component {
    state = {
        loading: true,
        logs: [],
        currentPage: 1,
        pageSize: 30,
        sortColumn: {path: "dateSorted", order: "desc"},
        searchQuery: "",
        status: null,
        dateRange: [new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1), new Date()]
    };
    genders = {
        mister: 'Homme',
        lady: 'Femme',
        miss: 'Demoiselle',
    };
    columns = [
        {
            path: "nameSorted",
            label: "Command",
            content: (request) => (
                <React.Fragment>
                    {request.command}
                </React.Fragment>
            ),
        },
        {
            label: "Args",
            content: (request) => (
                <React.Fragment>
                    {
                        Object.entries(request.args).map(([key, value]) => (
                            <div className="chip" key={key}>
                                {key}: {value}
                            </div>
                        ))
                    }
                </React.Fragment>
            ),
        },
        {
            path: "Processed",
            label: "Processed",
            content: (request) => (
                <React.Fragment>
                    {request.processed}
                </React.Fragment>
            ),
        },
        {
            path: "success",
            label: "Success",
            content: (request) => (
                <React.Fragment>
                    {request.success ? request.success : 0}
                </React.Fragment>
            ),
        },
        {
            path: "error",
            label: "Errors",
            content: (request) => (
                <React.Fragment>
                    {request.error ? request.error : 0}
                </React.Fragment>
            ),
        },
        {
            path: "status",
            label: "Status",
            content: (request) => (
                request.status === "success"
                    ? <span className="badge badge-success">SUCCESS</span> :
                    request.status === "failed" ?
                        <span className="badge badge-danger">ERROR</span> :
                        <span className="badge badge-warning">no lead to process</span>
            )
        },
        {
            path: "dateSorted",
            label: "Start Time",
            content: (request) => (
                moment(request.startTime).format('lll')
            ),
        },
        {
            path: "dateSorted",
            label: "End Time",
            content: (request) => (
                moment(request.endTime).format('lll')
            ),
        },
        {
            key: "actions",
            content: (request) => (
                <React.Fragment>
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-button-dark-example1" variant="transparent"
                                         className={"text-600 btn-reveal btn btn-link btn-sm"}>
                            <FaEllipsisH/>
                        </Dropdown.Toggle>

                        <Dropdown.Menu variant="dark">
                            <Dropdown.Item className={"p-0"}>
                                <Link to={`/logs_show/${request.id}`}
                                      className={"btn btn-light btn-block shadow-sm text-left"}>
                                    <FaEye/> Voir
                                </Link>
                            </Dropdown.Item>

                            {/*<Dropdown.Item className="p-0">
                                <button
                                    onClick={() => {
                                        Swal.fire({
                                            title: 'Etes-vous sûr?',
                                            text: 'Vous êtes sur le point de supprimer cette demande.',
                                            icon: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Oui, je le supprime!',
                                            cancelButtonText: 'Non, je le garde!'
                                        }).then(result => {
                                            if (result.isConfirmed) {
                                                if (this.handleDelete(request)) {
                                                    Swal.fire('Demande supprimée!', 'La demande a été bien supprimée.', 'success');
                                                } else {
                                                    Swal.fire('Demande non supprimée!', 'La demande n\'a pas été supprimée.', 'error');
                                                }
                                            } else {
                                            }
                                        });
                                    }}
                                    className={"btn btn-light btn-block shadow-sm text-left"}>
                                    <FaTrash/> Supprimer
                                </button>
                            </Dropdown.Item>*/}
                        </Dropdown.Menu>
                    </Dropdown>
                </React.Fragment>
            ),
        },
    ];

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.getRequests();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {location} = this.props;

        if (prevProps.location.key !== location.key) {
            this.getRequests();
        }

        if ((this.state.dateRange === null)
            || (!prevState.dateRange || (
                    prevState.dateRange[0] !== this.state.dateRange[0]
                    || prevState.dateRange[1] !== this.state.dateRange[1])
            )
            || prevState.currentPage !== this.state.currentPage
            || prevState.status !== this.state.status
            || prevState.searchQuery !== this.state.searchQuery
        ) {
            this.getRequests();
        }
    }

    getRequests = async () => {
        this.setState({loading: true});
        const {dateRange, currentPage, status} = this.state;

        const apiHelper = new ApiResourceHelper(`/logs`);

        const queryParams = [];

        queryParams.push({key: 'source', value: "xs"});

        if (dateRange && dateRange[0]) {
            queryParams.push({key: 'startTime%5Bafter%5D', value: getDate(dateRange[0])});
        }

        if (dateRange && dateRange[1]) {
            queryParams.push({key: 'startTime%5Bbefore%5D', value: `${getDate(dateRange[1])} 23:59`});
        }

        if (currentPage) {
            queryParams.push({key: 'page', value: currentPage});
        }
        if (status) {
            queryParams.push({key: 'status', value: status});
        }

        const {data} = await apiHelper.findBy(queryParams);

        const finalRequests = [];
        data["hydra:member"].forEach((r) => {
            const date = new Date(r.createdAt);
            const dateSorted = `${date.getFullYear()}/${date.getMonth()}/${date.getDay()} ${date.getHours()}:${date.getMinutes()}`;

            finalRequests.push({
                ...r, dateSorted, nameSorted: `${r.firstName} ${r.lastName}`
            });
        });

        this.setState({logs: finalRequests, loading: false, total: data["hydra:totalItems"]});
    };


    handleDelete = async (request) => {
        const originalRequests = this.state.logs;

        const logs = originalRequests.filter((b) => b.id !== request.id);
        this.setState({logs});

        try {
            await this.apiHelper.remove(`${this.apiPath}/${request.id}`);

            return true;
        } catch (ex) {
            if (ex.response && ex.response === 404)
                toast.error("This request has already been removed.");

            this.setState({logs: originalRequests});
            return false;
        }
    };

    handlePageChange = (page) => {
        this.setState({currentPage: page});
    };

    handleSort = (sortColumn) => {
        this.setState({sortColumn});
    };

    handleDateRangeChange = (dateRange) => {

        this.setState({
            searchQuery: "",
            currentPage: 1,
            dateRange
        });
    }

    getPagedData = () => {
        const {
            logs: allRequests,
            currentPage,
            pageSize,
            sortColumn,
            searchQuery,
        } = this.state;

        let filtered = allRequests;

        if (searchQuery) {
            filtered = allRequests.filter((b) =>
                b.email.toLowerCase().startsWith(searchQuery)
                || b.firstName.toLowerCase().startsWith(searchQuery)
                || b.lastName.toLowerCase().startsWith(searchQuery)
                || b.telephone.toLowerCase().startsWith(searchQuery)
                || (b.city && b.city.name.toLowerCase().startsWith(searchQuery))
            );
        }

        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

        const logs = paginate(sorted, currentPage, pageSize);

        return {totalCount: filtered.length, data: logs};
    };

    handleSearchChange = (query) => {
        this.setState({searchQuery: query, currentPage: 1});
    };

    getExportedData = () => {
        const {logs} = this.state;
        const exportedData = [];

        logs.forEach((item, index) => {
            const date = new Date(item.createdAt);

            const newItem = {
                date: `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)} ${date.getHours()}:${date.getMinutes()}`,
                nom: item.lastName + ' ' + item.firstName,
                email: item.email,
                telephone: item.telephone,
                ville: item.city ? item.city.name : '',
            }

            exportedData.push(newItem)
        });

        return exportedData;
    }
    onStatusChange = (event) => {
        this.setState({status: event.target.value});
    }

    render() {
        const {logs, total, currentPage, pageSize, sortColumn, dateRange, loading} = this.state;
        //const {totalCount, data: logs} = this.getPagedData();

        return (
            <React.Fragment>
                <Table
                    columns={this.columns}
                    data={logs}
                    //exportedData={this.getExportedData()}
                    exportedData={[]}
                    sortColumn={sortColumn}
                    onSort={this.handleSort}
                    tableName={"Webhelp Logs"}
                    tableTitle={"Webhelp Logs"}
                    searchQuery={this.state.searchQuery}
                    onSearchChange={this.handleSearchChange}
                    totalCount={total}
                    onPageChange={this.handlePageChange}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    dateRange={dateRange}
                    handleDateRangeChange={this.handleDateRangeChange}
                    loading={loading}
                    extraFilters={[
                        {
                            name: "result",
                            type: "select",
                            label: false,
                            options: [{key: "webhelpStatus", value: ""},
                                {key: "Success", value: "success"},
                                {key: "Error", value: "failed"},],
                            onChange: this.onStatusChange
                        },
                    ]}
                />
            </React.Fragment>
        );
    }
}

export default LogList;
